import React, { useState } from 'react';

// Optional video behind the hero, played once and left on its last frame (community.heroVideo, with a
// smaller heroVideoMobile for phones). The hero photo stays underneath as
// the first thing on screen; the video fades in over it once it's actually
// playing, so a slow connection just keeps the photo. Skipped for reduced
// motion and data-saver. On wide screens a portrait video is cropped to its
// middle band (object-fit: cover).
const HeroVideo = ({ src, mobileSrc }) => {
  const [playing, setPlaying] = useState(false);
  const [url] = useState(() => {
    if (typeof window === 'undefined' || !src) return null;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return null;
    if (navigator.connection?.saveData) return null;
    return mobileSrc && window.innerWidth <= 768 ? mobileSrc : src;
  });
  if (!url) return null;
  return (
    <video
      // iOS only autoplays video that's muted from the start, and React
      // doesn't write the `muted` attribute — so set it (and the property)
      // directly, then start it by hand in case autoplay was skipped.
      ref={(el) => {
        if (!el || el.dataset.ready) return;
        el.dataset.ready = '1';
        el.muted = true;
        el.defaultMuted = true;
        el.setAttribute('muted', '');
        el.setAttribute('playsinline', '');
        el.play?.()?.catch(() => {});
      }}
      src={url}
      autoPlay
      muted
      playsInline
      preload="auto"
      aria-hidden="true"
      onPlaying={() => setPlaying(true)}
      style={{
        position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, width: '100%', height: '100%',
        objectFit: 'cover', zIndex: 0, opacity: playing ? 1 : 0, transition: 'opacity 0.8s ease',
      }}
    />
  );
};

export default HeroVideo;
